import { HttpClient, HttpContext, HttpHeaders } from '@angular/common/http';
import { ApiConfiguration } from '../api-configuration';
import { BaseService } from '../base-service';
import { Injectable } from '@angular/core';
import { LanguageListModel } from '../models/language-list-model';
import { map, Observable } from 'rxjs';
import { StrictHttpResponse } from '../strict-http-response';
import { listLanguagesGet } from '../fn/translation/list-languages-get';

@Injectable({ providedIn: 'root' })
export class TranslationService extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /**
   * Lists available languages for translation
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `listLanguagesGet()` instead.
   */
  listLanguagesGet$Response(
    headers: HttpHeaders,
    context?: HttpContext,
  ): Observable<StrictHttpResponse<LanguageListModel>> {
    return listLanguagesGet(this.http, this.rootUrl, headers, context);
  }

  /**
   * Lists available languages for translation
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `listLanguagesGet$Response()` instead.
   */
  listLanguagesGet(
    headers: HttpHeaders,
    context?: HttpContext,
  ): Observable<LanguageListModel> {
    return this.listLanguagesGet$Response(headers, context).pipe(
      map(
        (r: StrictHttpResponse<LanguageListModel>): LanguageListModel => r.body,
      ),
    );
  }
}
